export const trackDataLayerEvent = dataEvent => {
  const eventValue = "click_event " + (dataEvent.id || "")

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: eventValue,
    eventAction: "click",
    ...dataEvent,
  })
}
